export default "__VITE_ASSET__BokIAdJc__"